import { Database, Users, TrendingUp } from "lucide-react";

const Stat = ({ icon: Icon, label, value, hint }) => (
  <div className="rounded-lg border border-slate-200 bg-white p-5">
    <div className="flex items-center gap-2 text-slate-500">
      <Icon size={14} />
      <span className="text-[11px] uppercase tracking-[0.2em] font-semibold">
        {label}
      </span>
    </div>
    <p className="mt-2 font-display text-3xl font-black text-slate-900">
      {value ?? "—"}
    </p>
    {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
  </div>
);

export const AdminStats = ({ counts, stats }) => (
  <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <Stat
      icon={Database}
      label="Roles"
      value={counts?.roles}
      hint="From Roles sheet"
    />
    <Stat
      icon={Database}
      label="Skills (catalog)"
      value={counts?.skills}
      hint={`${counts?.technical || 0} technical · ${counts?.soft || 0} soft`}
    />
    <Stat
      icon={Users}
      label="Assessments"
      value={stats?.total_responses}
      hint="Submissions stored"
    />
    <Stat
      icon={TrendingUp}
      label="Top role"
      value={stats?.top_primary_roles?.[0]?.role || "—"}
      hint={
        stats?.top_primary_roles?.[0]
          ? `${stats.top_primary_roles[0].count} primaries`
          : ""
      }
    />
  </div>
);

export default AdminStats;
